const STATUS_MAP = {
	pending: 'Oczekuje na zapłatę',
	processing: 'W trakcie realizacji',
	shipped: 'Wysłane',
	completed: 'Dostarczone',
	cancelled: 'Anulowane',
};

export function formatStatus(status) {
	if (!status) return STATUS_MAP.pending;
	const key = String(status).toLowerCase();
	return STATUS_MAP[key] || (status.charAt(0).toUpperCase() + status.slice(1));
}

export const STATUS_OPTIONS = Object.keys(STATUS_MAP).map(k => ({ value: k, label: STATUS_MAP[k] }));

export default formatStatus;
